import React from "react";
import PropTypes from "prop-types";
import {
  TitleAboveInput,
  FileInputWrapper,
  UploadFileDetailsWrapper,
  FileWrapper,
  CloseIconWrapper,
  MainContentWrapper,
} from "./styled/FileUpload.styled";
import File from "./elements/File";
import { AiOutlineCloseCircle } from "react-icons/ai";
export default function FileUpload({
  title,
  clickUpload,
  file,
  onChangeFile,
  hiddenFileInput,
  onDeselectFile,
  fileUrl,
  ...props
}) {
  return (
    <>
      <TitleAboveInput>{title}</TitleAboveInput>
      <MainContentWrapper>
        <FileInputWrapper variant={"outlined"} onClick={clickUpload}>
          Choose Document
        </FileInputWrapper>
        <UploadFileDetailsWrapper>
          {(file || fileUrl) && (
            <>
              <FileWrapper>
                <File fileName={file ? file.name : fileUrl} disabled />
              </FileWrapper>
              <CloseIconWrapper>
                <AiOutlineCloseCircle onClick={onDeselectFile} />
              </CloseIconWrapper>
            </>
          )}
        </UploadFileDetailsWrapper>
      </MainContentWrapper>
      <input
        type="file"
        onChange={onChangeFile}
        style={{ display: "none" }}
        ref={hiddenFileInput}
      />
    </>
  );
}

FileUpload.propTypes = {
  fileUrl: PropTypes.string,
  title: PropTypes.string,
  clickUpload: PropTypes.func,
  file: PropTypes.object,
  onChangeFile: PropTypes.func,
  onDeselectFile: PropTypes.func,
  hiddenFileInput: PropTypes.any,
};

FileUpload.defaultProps = {
  fileUrl: null,
  title: null,
  clickUpload: () => {},
  file: null,
  onChangeFile: () => {},
  onDeselectFile: () => {},
  hiddenFileInput: undefined,
};
